var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonVideoGallery.jinja');
require('./CommonVideoGallery.less');

var objectFitImages = require('object-fit-images');
require('assets/owl.carousel.min.css');
require('assets/owl.theme.default.min.css');
require('owl.carousel.min-2.2.1.js');

module.exports = Base.extend({

    template: template,

    events: {
        'click .CommonVideoGallery-item': 'changeVideo'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'nextVideo');

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        var carouselSelector = '.CommonVideoGallery-galleryCarousel';

        this.$owlh = this.$(carouselSelector);
        window.app.vent.on('CommonVideoPlayer', this.nextVideo);

        this.initGallery();
    },


    destroy: function () {
        this.destroyed = true;

        return Base.prototype.destroy.call(this);
    },

    changeVideo: function (item) {
        var $item = $(item.currentTarget);
        var idVideo = $item.attr('data-id');

        window.app.vent.trigger('CommonVideoGallery-change-video', idVideo);
    },

    nextVideo: function (id) {
        var $nextVideo = this.$('.CommonVideoGallery-item[data-id="' + id + '"]');

        if (!$nextVideo.parent().hasClass('active')) {
            this.$owlh.trigger('next.owl.carousel');
        }
        this.$('.CommonVideoGallery-item.play').removeClass('play');
        $nextVideo.addClass('play');
    },


    initGallery: function () {
        var itemsCount = this.$('.CommonVideoGallery-item').length;

        this.$owlh.owlCarousel({
            items: 4,
            nav: itemsCount > 4,
            dots: itemsCount > 2,
            dotsEach: Math.ceil(itemsCount / 10), //no more than 10 dots
            mouseDrag: false,
            smartSpeed: 500,
            slideBy: 'page',
            responsive:{
                0:{
                    items: 2
                },
                768: {
                    items: 4
                }
            }
        });

        this.$owlh
            .find('.owl-prev')
            .html(this.$('.CommonVideoGallery-galleryPrev svg'));

        this.$owlh
            .find('.owl-next')
            .html(this.$('.CommonVideoGallery-galleryNext svg'));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonVideoGallery/CommonVideoGallery.js
// module id = 178
// module chunks = 0